import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_IPO_CALCULATE_FOR_USER } from "../../../config/api";

// Read-only quote. data: { user_id, mode: "amount" | "shares", amount | shares }.
// Returns 200 even when the input is invalid — the caller branches on
// summary.is_valid / summary.validation_message, not on the HTTP status.
export const calculateIpoForUser = createAsyncThunk(
  "ipos/calculateForUser",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_IPO_CALCULATE_FOR_USER(id),
        data,
      });
      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
